export default class Locale_ObjectListEditor { 
	AdditionalActions: string = 'Additional actions';
	CopyToNew: string = "Copy to new";
}